export const checkout_preview_keys = {
    listing_details: "listingDetails",
    listing_title: "listingTitle",
    creator_image: "creatorImage",
    creator_name: "creatorName",
    description_section: "descriptionSection",
    description: "description",
    cover_section: "coverSection",
    cover_image: "coverImage",
    button_text_section: "buttonTextSection",
    button_type: "buttonType",
    cta_data: "ctaData",
    color_palette: "colorPalette",
    tab_assets: "tabAssets",
    tab_title: "tabTitle",
    tab_icon: "tabIcon",
    order_bumps_heading_section: "orderBumpsHeadingSection",
    heading: "heading",
    order_bumps_details: "orderBumpsDetails",
};
